import React from 'react';
import PropTypes from 'prop-types';
import { dateToString } from '../../common/utils/date/Date.utils';

function EditDealerNotesTableRow({ item }) {
  const { createdOn, createdBy, content } = item;

  return (
    <>
      <td>{createdOn && dateToString(createdOn)}</td>
      <td>{createdBy}</td>
      <td className="dealer-note-table-content">{content}</td>
    </>
  );
}

EditDealerNotesTableRow.propTypes = {
  item: PropTypes.object,
};
EditDealerNotesTableRow.defaultProps = {
  item: {},
};

export default EditDealerNotesTableRow;
